module.exports =
  ENV: 'production'
  baseApiUrl: 'https://api.beautiti.ru'
